import Vue from 'vue'

// 美国存股证（ADR） 展示信息
Vue.filter('parseAdr', value => {
  const formatVal = (value - 0).toFixed(2)
  let denominator = 100
  let numerator = formatVal * 100
  let bigger = 0
  function recursion() {
    bigger = denominator > numerator ? denominator : numerator
    for (let i = bigger; i > 1; i--) {
      if (
        Number.isInteger(numerator / i) &&
        Number.isInteger(denominator / i)
      ) {
        numerator = numerator / i
        denominator = denominator / i
        recursion()
      }
    }
  }
  recursion()
  return `${denominator} : ${numerator}`.toString()
})
